import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../../actionTypes';

import { deleteInfoRequestCompleted, infoRequest } from '../../actions';

const { takeEvery, put, take } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();
    try {
        for (const lang of config.app.languages) {
            const ref = yield firestore.doc(`languages/${lang}/infoCategories/${meta.categoryId}/info/${meta.id}`);
            yield ref.delete();
        }
        message.success(intl.formatMessage({ id: 'success.info.delete' }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.info.delete' }));
    } finally {
        yield put(infoRequest(meta.categoryId, { silent: true }));
        yield take(types.INFO_REQUEST_COMPLETED);
        yield put(deleteInfoRequestCompleted(meta.id));
    }
}
export default function* () {
    yield takeEvery(types.DELETE_INFO_REQUEST, handler);
}
